import React from "react";
import { Button } from "react-bootstrap";
import Searchresult from "./Searchresult";
import btc from "../../../assets/images/withdraw/bitcoin.svg";
import trx from "../../../assets/images/withdraw/eth.svg";
import xrp from "../../../assets/images/withdraw/xrp.svg";
import tether from "../../../assets/images/withdraw/tether.svg";
import lite from "../../../assets/images/withdraw/binance.svg";

import "./coinsearch_styles/searchresultlist.css";
import { useDispatch } from "react-redux";
import { coinInfo } from "../../../store/withdraw";

export default function Searchresultlist({ searchResults, setSelectedOption, closeModal, setSearchResults, data }) {
  const dispatch = useDispatch()
  const selectItem = async (item: any) => {
    console.log('selected item',item)
    dispatch(coinInfo({
      coinId:item.coinId,
      coinName:item.label,
      coinSymbol:item.value
    }))
    

    setSelectedOption(item)
    closeModal()
    setSearchResults(data)

  }
  return (
    <>


      {searchResults.map((result: any, id: any) => {
        return <div className='search-result' key={id} onClick={() => { selectItem(result) }} >

          <img src={`data:${result.contentType};base64, ${result.imgUrl}`} className='img-fluid me-2' width={35} height={35} />


          {result.label}


        </div>;
      })}

    </>
  );
}

